export default class SleepHelper {
  static async sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  static async wait(fnc, maxWait = 2000, pollingFrequency = 50) {
    if (typeof fnc !== 'function') {
      throw new Error('input of wait() must be a function');
    }

    return new Promise((resolve, reject) => {
      let pid = setInterval(() => {
        let res = fnc();
        if (res) {
          clearInterval(pid);
          pid = null;
          resolve(res);
        }
      }, pollingFrequency);

      setTimeout(() => {
        if (pid) {
          clearInterval(pid);
          reject(`max-timeout exceeded ${maxWait}ms`);
        }
      }, maxWait);
    });
  }
}
